import _toConsumableArray from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

export function index(items, _ref) {
  var identifier = _ref.identifier,
      indexes = _ref.indexes;
  var indexData = {};
  var indexDataSorted = {};

  var _iterator = _createForOfIteratorHelper(items),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _item = _step.value;
      var id = identifier(_item);

      for (var _i2 = 0, _Object$entries2 = Object.entries(indexes); _i2 < _Object$entries2.length; _i2++) {
        var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
            _hash = _Object$entries2$_i[0],
            _index2 = _Object$entries2$_i[1];

        var buckets = _index2.indexer(_item);

        var _iterator2 = _createForOfIteratorHelper(buckets),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var bucket = _step2.value;
            indexData[_hash] = indexData[_hash] || {
              title: _index2.title,
              buckets: {}
            };
            var targetIndex = indexData[_hash];
            targetIndex.buckets[bucket.hash] = targetIndex.buckets[bucket.hash] || {
              title: bucket.title,
              ids: []
            };
            var targetBucket = targetIndex.buckets[bucket.hash];
            targetBucket.ids.push(id);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    } // Sort buckets A to Z

  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  for (var _i = 0, _Object$entries = Object.entries(indexData); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        hash = _Object$entries$_i[0],
        _index = _Object$entries$_i[1];

    var sortedBuckets = Object.entries(_index.buckets).sort(function (bucketA, bucketB) {
      if (bucketA[1].title < bucketB[1].title) {
        return -1;
      }

      if (bucketA[1].title > bucketB[1].title) {
        return 1;
      }

      return 0;
    });
    var sortedBucketsFormatted = sortedBuckets.reduce(function (sortedItems, items) {
      return _objectSpread(_objectSpread({}, sortedItems), {}, _defineProperty({}, items[0], items[1]));
    }, {});
    indexDataSorted[hash] = _objectSpread(_objectSpread({}, _index), {}, {
      buckets: _objectSpread({}, sortedBucketsFormatted)
    });
  }

  return indexDataSorted;
}
export function search(_x, _x2, _x3) {
  return _search.apply(this, arguments);
}

function _search() {
  _search = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(items, config, query) {
    var list, facets, _i3, _Object$entries3, _Object$entries3$_i, indexHash, _index3, _i4, _Object$entries4, _Object$entries4$_i, bucketHash, bucket, queriedBuckets, virtualFilters, virtualResult, count, filter, matchFilters, matchFilter;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            matchFilter = function _matchFilter(id, index, buckets) {
              return buckets.some(function (bucket) {
                var ids = config.index[index].buckets[bucket].ids;
                return ids.includes(id);
              });
            };

            matchFilters = function _matchFilters(item, filters) {
              if (Object.keys(filters).length === 0) {
                return true;
              }

              var id = config.identifier(item);
              return Object.entries(filters).every(function (_ref2) {
                var _ref3 = _slicedToArray(_ref2, 2),
                    index = _ref3[0],
                    buckets = _ref3[1];

                return matchFilter(id, index, buckets);
              });
            };

            filter = function _filter(items, query) {
              return items.filter(function (item) {
                return matchFilters(item, query.filters) && config.fullText(query.text, item);
              });
            };

            list = filter(items, query);
            _context.next = 6;
            return new Promise(function (res) {
              return setTimeout(res, 0);
            });

          case 6:
            facets = {};
            _i3 = 0, _Object$entries3 = Object.entries(config.index);

          case 8:
            if (!(_i3 < _Object$entries3.length)) {
              _context.next = 33;
              break;
            }

            _Object$entries3$_i = _slicedToArray(_Object$entries3[_i3], 2), indexHash = _Object$entries3$_i[0], _index3 = _Object$entries3$_i[1];
            facets[indexHash] = {
              title: _index3.title,
              buckets: {}
            };
            _i4 = 0, _Object$entries4 = Object.entries(_index3.buckets);

          case 12:
            if (!(_i4 < _Object$entries4.length)) {
              _context.next = 30;
              break;
            }

            _Object$entries4$_i = _slicedToArray(_Object$entries4[_i4], 2), bucketHash = _Object$entries4$_i[0], bucket = _Object$entries4$_i[1];
            queriedBuckets = query.filters[indexHash] || [];

            if (!queriedBuckets.includes(bucketHash)) {
              _context.next = 19;
              break;
            }

            facets[indexHash].buckets[bucketHash] = {
              title: bucket.title,
              count: list.length
            };
            _context.next = 27;
            break;

          case 19:
            _context.next = 21;
            return new Promise(function (res) {
              return setTimeout(res, 0);
            });

          case 21:
            virtualFilters = _objectSpread(_objectSpread({}, query.filters), {}, _defineProperty({}, indexHash, [].concat(_toConsumableArray(queriedBuckets), [bucketHash])));
            virtualResult = filter(items, {
              text: query.text,
              filters: virtualFilters
            });
            _context.next = 25;
            return new Promise(function (res) {
              return setTimeout(res, 0);
            });

          case 25:
            count = filter(virtualResult, {
              text: query.text,
              filters: _defineProperty({}, indexHash, [bucketHash])
            }).length;
            facets[indexHash].buckets[bucketHash] = {
              title: bucket.title,
              count: count
            };

          case 27:
            _i4++;
            _context.next = 12;
            break;

          case 30:
            _i3++;
            _context.next = 8;
            break;

          case 33:
            return _context.abrupt("return", {
              list: list,
              facets: facets
            });

          case 34:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _search.apply(this, arguments);
}